export default __webpack_public_path__ + "static/media/LolChampionGalleryImg_4.420a18f4.webp";